<template>
  <div>
    <div>
      {{ toAddressString(shipment.recipient) }}
    </div>

    <div>
      <small class="text-muted">
        {{ addressOwner(shipment.recipient) }}
      </small>
    </div>

    <div v-if="notifications.length" class="text-danger pt-2">
      <div v-for="(notification, index) in notifications" :key="index">
        <i class="fa fa-exclamation-triangle fa-fw" />
        {{ notification }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { Shipment } from '@/types/Models/Shipment'
import { defineComponent, computed, type PropType, type ComputedRef } from 'vue'
import { useAddressTransformers } from '@/composables/Address/useAddressTransformers'

export default defineComponent({
  name: 'RecipientCell',
  props: {
    shipment: {
      type: Object as PropType<Shipment>,
      required: true,
    },
  },
  setup(props) {
    const notifications: ComputedRef<string[]> = computed(() => {
      const buffer: string[] = []

      if (props.shipment.hasTrackingError && props.shipment.lastTrackingEventDescription) {
        buffer.push(props.shipment.lastTrackingEventDescription)
      }

      return buffer
    })

    const { toAddressString, addressOwner } = useAddressTransformers()

    return {
      notifications,
      toAddressString,
      addressOwner,
    }
  },
})
</script>
